import React, { useState } from 'react';
import { reviews } from '../mock/reviewsData';
import { Star, Quote, ChevronLeft, ChevronRight, ExternalLink } from 'lucide-react';

const Reviews = () => {
  const [index, setIndex] = useState(0);
  const pageSize = 3;
  const totalPages = Math.ceil(reviews.length / pageSize);

  const visible = reviews.slice(index * pageSize, index * pageSize + pageSize);

  const next = () => setIndex((i) => (i + 1) % totalPages);
  const prev = () => setIndex((i) => (i - 1 + totalPages) % totalPages);

  return (
    <section className="bg-gradient-to-b from-white to-slate-50 py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-emerald-50 text-emerald-700 px-4 py-1.5 rounded-full text-sm font-medium border border-emerald-100 mb-4">
            <Star className="w-4 h-4 fill-emerald-600 text-emerald-600" /> 5 on Google Reviews
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0F2A4B]">Know what our customers say</h2>
          <p className="mt-3 text-slate-600 text-lg">Real stories from people who secured their future with us</p>
        </div>

        <div className="relative">
          <div className="grid md:grid-cols-3 gap-5">
            {visible.map((r, i) => (
              <div key={`${index}-${i}`} className="group bg-white rounded-2xl border border-slate-100 p-7 hover:shadow-xl hover:border-emerald-200 transition-all relative">
                <Quote className="absolute top-5 right-5 w-8 h-8 text-emerald-100" />
                <div className="flex items-center gap-1 mb-4">
                  {Array.from({ length: r.rating }).map((_, k) => (
                    <Star key={k} className="w-4 h-4 fill-yellow-400 text-yellow-400" />
                  ))}
                </div>
                <p className="text-slate-700 text-[15px] leading-relaxed mb-6 min-h-[120px]">“{r.text}”</p>
                <div className="flex items-center gap-3 pt-4 border-t border-slate-100">
                  <div className="w-11 h-11 rounded-full bg-gradient-to-br from-emerald-400 to-teal-500 flex items-center justify-center text-white font-bold">
                    {r.name.split(' ').map((w) => w[0]).slice(0, 2).join('')}
                  </div>
                  <div>
                    <div className="font-semibold text-[#0F2A4B] text-sm">{r.name}</div>
                    <div className="text-xs text-slate-500">{r.role} • {r.location}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="flex items-center justify-center gap-3 mt-10">
            <button onClick={prev} className="w-11 h-11 rounded-full bg-white border border-slate-200 hover:border-[#00B48E] hover:text-[#00B48E] text-slate-600 flex items-center justify-center shadow-sm transition-colors">
              <ChevronLeft className="w-5 h-5" />
            </button>
            <div className="flex gap-2">
              {Array.from({ length: totalPages }).map((_, i) => (
                <button
                  key={i}
                  onClick={() => setIndex(i)}
                  className={`transition-all rounded-full ${i === index ? 'w-8 h-2 bg-[#00B48E]' : 'w-2 h-2 bg-slate-300 hover:bg-slate-400'}`}
                />
              ))}
            </div>
            <button onClick={next} className="w-11 h-11 rounded-full bg-white border border-slate-200 hover:border-[#00B48E] hover:text-[#00B48E] text-slate-600 flex items-center justify-center shadow-sm transition-colors">
              <ChevronRight className="w-5 h-5" />
            </button>
          </div>

          <div className="text-center mt-8">
            <a
              href="https://www.google.com/search?q=InsureRiskFree+Solutions+Reviews"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-sm font-semibold text-[#00B48E] hover:underline"
            >
              Read all reviews on Google <ExternalLink className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Reviews;
